<template>
		<v-container >
			<v-layout row wrap>
				<v-flex xs12 sm10 md8 lg7>
					<v-card>
						<v-alert
                    v-model="alertInput"
                    dismissible
                    type="error"
                  >
                    'Upps something is wrong! Please correct the mistakes'
                  </v-alert>
						<v-toolbar :color="cr.colorName">
							<v-toolbar-title  :color='cr.colorName' class="body-3 white--text">{{title}}</v-toolbar-title>
							&nbsp;<v-icon dark class="pt-0">{{icon}}</v-icon>
						</v-toolbar>
      			<v-spacer></v-spacer>
						<v-card-text>
							<v-container>
								<v-form ref="form">
			        		  <h2>Description</h2>
			              <v-layout row>
			              	<v-flex>
			      							<v-text-field
											        label="Portal Name"
											        hint= "Name of the station ie. San Pedro Station"
											        persistent-hint
											        v-model="portal_name"
											         :error-messages="errors.collect('portal_name')"
											        v-validate="'required|max:75'"
											        data-vv-name="portal_name"
											        required
											      ></v-text-field>        		
			              	</v-flex>
			              </v-layout>
			              <v-layout row>
			              	<v-flex>
			              		  <v-text-field
											        label="Location Description"
											        hint= "Ex: Portal South...  "
											        persistent-hint
											        v-model="loc_descrp"
											         :error-messages="errors.collect('loc_descrp')"
											        v-validate="'required|max:50'"
											        data-vv-name="loc_descrp"
                              disable
											        required
											      ></v-text-field>
			              	</v-flex>
			              </v-layout>
			               <v-layout row>
			              	<v-flex>
										      <v-text-field
										        label="Display Case Code"
										        hint= "Example B_GR_2e"
										        persistent-hint
										        v-model="code"
										         :error-messages="errors.collect('code')"
										        v-validate="'required|max:15|regex:^[A-Za-z]+\_[0-9A-Z]+\_[0-9A-Z]+'"
										        data-vv-name="code"
										        required
                            :readonly = "readonly"
										      ></v-text-field>
										    </v-flex>
										   </v-layout>
			      					<v-spacer class="blue--text lighten-2 mt-4 mb-2"></v-spacer>
			        				<v-layout row>
			              		<v-flex>
			              			<h2>Properties</h2>
										      <v-select
							              v-bind:items="displayType"
							              v-model="type"
							              label="Type"
							              class="input-group--focused"
							              item-value="text"
							              :hint= "typeHint"
							              persistent-hint
							               :error-messages="errors.collect('type')"
							              v-validate="'required'"
							              data-vv-name="type"
							              required
							              ></v-select>
						           	</v-flex>
						         </v-layout>
						           <v-layout row>
			              		<v-flex>
			            				<v-text-field
											        label="Size"
											        hint= "Size of the diplay 47x47"
											        persistent-hint
											        v-model="size"
											         :error-messages="errors.collect('size')"
											        v-validate="'required|max:25'"
											        data-vv-name="size"
											        required
											      ></v-text-field>
											    </v-flex>
											  </v-layout>
											   <v-layout row>
					              		<v-flex>
													      <v-text-field
													        label="Latitude"
													        hint= "Latitude from 33.00 to 35.00"
													        persistent-hint
													        v-model="latitude"
													        :error-messages="errors.collect('latitude')"
													        v-validate="'required|between:33,35|decimal:6'"
													        data-vv-name="latitude"
													      ></v-text-field>
													  </v-flex>	
												</v-layout>
												<v-layout row>
			              		<v-flex>
										      <v-text-field
										        label="Longitude"
										        hint= "Longitude from -119.00 to -117.00"
										        persistent-hint
										        v-model="longitude"
										         :error-messages="errors.collect('longitude')"
										        v-validate="'required|between:-119,-117|decimal:7'"
										        data-vv-name="longitude"
										      ></v-text-field>
										    </v-flex>
										  </v-layout>
										   <v-layout row>
			              		<v-flex>
									      	<v-select
									              v-bind:items="sharedDisplay"
									              v-model="shared"
									              label="Shared"
									              class="input-group--focused"
									              item-value="text"
									              :hint="sharedHint" 
									        persistent-hint
									         :error-messages="errors.collect('shared')"
									              v-validate="'required'"
									              data-vv-name="shared"
									              required
									            ></v-select>
								            </v-flex>
							            </v-layout>
							         <v-layout row>
			              		<v-flex>
							            <v-select
							              v-bind:items="displayStatus"
							              v-model="status"
							              label="Status"
							              class="input-group--focused"
							              item-value="text"
							              :hint= "statusHint"
							        persistent-hint
							         :error-messages="errors.collect('status')"
							              v-validate="'required'"
							              data-vv-name="status"
							              required
							            ></v-select>
							          </v-flex>
							        </v-layout>
								 <v-layout row>
			           		<v-flex>
			      		      <v-btn class='white--text'  :color="cr.colorName" @click="validate()">Save <v-icon class="pl-1">check_circle</v-icon></v-btn>
				        			<v-btn  class='white--text'  :color="cr.colorName" @click="cancel()">Cancel <v-icon class="pl-1">cancel</v-icon></v-btn>
				        		</v-flex>
				        	</v-layout>
								</v-form>			
							</v-container>
		      	</v-card-text>
		      </v-card>
				</v-flex>
			</v-layout>
		</v-container>
</template>
<script>
  import {bus} from '../../main'
  import {mapGetters} from 'vuex'
  export default {
    props: {
      addInfo: {
        type: Object
      },
      cr: {
        type: Object
      },
      openAddForm: {
        type: Boolean
      },
      readonly: {
        type: Boolean
      },
      railId: {
        type: String
      },
      editDisplayFromSearch: {
        type: Object
      },
      data: {
        type: Object
      },
      item_code: {
        type: String
      },
      id: {
        type: String
      },
      search: {
        type: Boolean
      },
      displayEdit: {
        type: Object
      }
    },
    data () {
      return {
        alertInput: false,
        menuDateCreated: false,
        menuDateUpdated: false,
        dateOpen: null,
        dateUpdated: null,
        portal_name: '',
        title: 'Add Display',
        icon: 'add_circle',
        loc_descrp: '',
        dplay_id: '',
        code: '',
        station_code: '',
        station_loc: '',
        size: '',
        shared: '',
        type: '',
        latitude: null,
        longitude: null,
        mTicket: '',
        status: '',
        comments: '',
        picture: '',
        image: null,
        imageUrl: '',
        displayType: ['Backlit', 'Non-backlit', 'Bus Shelter'],
        displayStatus: ['Active', 'Empty', 'Needs Repair'],
        sharedDisplay: ['Yes', 'No'],
        typeHint: 'Type of display example Backlit, Non-backlit, or Bus Shelter',
        statusHint: 'Status of the display',
        sharedHint: 'select if display shared between multiple lines',
        openForms: {
          add_Display: false,
          edit_Display: false,
          search: false,
          searchDisplayEdit: false
        }
      }
    },
    computed: {
      ...mapGetters({currentUser: 'currentUser'})
    },
    watch: {
      displayEdit (d) {
        this.title = 'Edit Display'
        this.icon = 'edit'
        this.portal_name = d.portal_name
        this.loc_descrp = d.loc_descrp
        this.code = d.code
        this.size = d.size
        this.latitude = d.latitude
        this.longitude = d.longitude
        this.typeHint = 'Select the current value of "' + d.displayType + '" unless you want to change it'
        this.type = d.displayType
        this.statusHint = 'Select the current value of "' + d.status + '" unless you want to change it'
        this.status = d.status
        this.shared = d.isShared
        this.sharedHint = 'Select the current value of "' + d.isShared + '" unless you want to change it'
        this.openForms.edit_Display = true
        this.openForms.add_Display = false
        this.openForms.search = false
        this.openForms.searchDisplayEdit = false
        this.dplay_id = d.id
      },
      editDisplayFromSearch (d) {
        this.title = 'Edit Display'
        this.icon = 'edit'
        this.portal_name = d.portal_name
        this.loc_descrp = d.loc_descrp
        this.code = d.code
        this.size = d.size
        this.latitude = d.latitude
        this.longitude = d.longitude
        this.typeHint = 'Select the current value of "' + d.displayType + '" unless you want to change it'
        this.type = d.displayType
        this.statusHint = 'Select the current value of "' + d.status + '" unless you want to change it'
        this.status = d.status
        this.shared = d.isShared
        this.sharedHint = 'Select the current value of "' + d.isShared + '" unless you want to change it'
        this.openForms.edit_Display = false
        this.openForms.add_Display = false
        this.openForms.search = false
        this.openForms.searchDisplayEdit = true
        this.dplay_id = d.id
      },
      openAddForm () { // adding a new display
        this.openForms.add_Display = true
        this.openForms.edit_Display = false
        this.openForms.search = false
        this.openForms.searchDisplayEdit = false
        this.title = 'Add Display'
        this.icon = 'add_circle'
        this.portal_name = this.addInfo.name
      }
    },
    methods: {
      validate () {
        var vm = this
        vm.$validator.validateAll().then((results) => {
          if (results) {
            vm.save()
          } else {
            vm.alertInput = true
          }
        })
      },
      save () {
        var vm = this
        if (vm.openForms.edit_Display) { // edit display
          let obj = {
            portal_name: vm.portal_name,
            loc_descrp: vm.loc_descrp,
            code: vm.code,
            displayType: vm.type,
            size: vm.size,
            latitude: vm.latitude,
            longitude: vm.longitude,
            isShared: vm.shared,
            status: vm.status,
            featureFk: vm.displayEdit.featureFk,
            displayId: vm.displayEdit.displayId,
            userFk: vm.currentUser.id,
            d_id: vm.dplay_id,
            rline: vm.cr.name
          }
          console.log(obj)
          var url = '/mapsdata/display/editdisplay'
          vm.$http.post(url, obj)
          .then(function (response) {
            bus.$emit('closeFormDisplayEdit', false)
            bus.$emit('saveForm', true)
          })
        }
        if (vm.openForms.searchDisplayEdit) { // edit display from search
          let obj = {
            portal_name: vm.portal_name,
            loc_descrp: vm.loc_descrp,
            code: vm.code,
            displayType: vm.type,
            size: vm.size,
            latitude: vm.latitude,
            longitude: vm.longitude,
            isShared: vm.shared,
            status: vm.status,
            featureFk: vm.editDisplayFromSearch.featureFk,
            displayId: vm.editDisplayFromSearch.displayId,
            userFk: vm.currentUser.id,
            d_id: vm.dplay_id,
            rline: vm.cr.name
          }
          var uri = '/mapsdata/display/editdisplay'
          vm.$http.post(uri, obj)
          .then(function (response) {
            let it = {
              msg: 'Successfully edit'
            }
            vm.$store.dispatch('closeForm')
            bus.$emit('saveSearchEdit', it)
          })
        }
        if (vm.openForms.add_Display) { // adding new display
          let vm = this
          let url = '/mapsdata/display/createdisplay'
          if (vm.addInfo.portalFeature.length !== 0) {
            let addObj = {
              portal_name: vm.portal_name,
              loc_descrp: vm.loc_descrp,
              code: vm.code,
              displayType: vm.type,
              size: vm.size,
              latitude: vm.latitude,
              longitude: vm.longitude,
              isShared: vm.shared,
              status: vm.status,
              featureFk: vm.addInfo.portalFeature[0].id,
              displayId: vm.addInfo.portalFeature[0].featureDisplay[0].displayId,
              stop_id: vm.addInfo.stopId,
              railId: vm.railId,
              userFk: vm.currentUser.id,
              d_id: vm.dplay_id,
              rline: vm.cr.name
            }
            vm.$http.post(url, addObj)
            .then(function (response) {
              vm.$refs.form.reset()
              bus.$emit('closeFormDisplayAdd', false)
              bus.$emit('saveForm', true)
            })
          } else {
            let addObj_ = {
              portal_name: vm.portal_name,
              loc_descrp: vm.loc_descrp,
              code: vm.code,
              displayType: vm.type,
              size: vm.size,
              latitude: vm.latitude,
              longitude: vm.longitude,
              isShared: vm.shared,
              status: vm.status,
              featureFk: '',
              stop_id: vm.addInfo.stopId,
              displayId: '',
              railId: vm.railId,
              userFk: vm.currentUser.id,
              d_id: vm.dplay_id,
              rline: vm.cr.name
            }
            vm.$http.post(url, addObj_)
            .then(function (response) {
              vm.$refs.form.reset()
              bus.$emit('closeFormDisplayAdd', false)
              bus.$emit('saveForm', true)
            })
          }
        }
      },
      cancel () {
        if (this.openForms.edit_Display) {
          this.$validator.reset()
          bus.$emit('closeFormDisplayEdit', false)
        }
        if (this.openForms.add_Display) { // close add display
          this.$validator.reset()
          this.imageUrl = ''
          this.$refs.form.reset()
          bus.$emit('closeFormDisplayAdd', false)
        }
        if (this.openForms.search) { // close form from search
          this.$validator.reset()
          this.$refs.form.reset()
          this.$store.dispatch('closeForm')
        }
        if (this.openForms.searchDisplayEdit) { // close edit form from search
          this.$validator.reset()
          this.$store.dispatch('closeForm')
        }
      },
      uploadFile () {
        this.$refs.fileInput.click()
      },
      filePicked (event) {
        const files = event.target.files
        let fname = files[0].name
        if (fname.lastIndexOf('.') <= 0) {
          return alert('Please add a valid file')
        }
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          this.imageUrl = fileReader.result
        })
        fileReader.readAsDataURL(files[0])
      },
      resetOpenForms () {
        this.alertInput = false
        this.openForms.edit_Display = false
        this.openForms.add_Display = false
        this.openForms.search = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Forms/AddDisplay.vue